import * as S from './style';

const SponsorshipGuide = () => (
	<S.SponsorshipContainer>
		<S.HeroCard>
			<S.HeroEyebrow>Sponsorship</S.HeroEyebrow>
			<S.HeroTitle>대한화장품학회 후원 및 기부금 안내</S.HeroTitle>
			<S.HeroDescription>
				대한화장품학회는 법인세법시행령 제39조제1항제1호제바목에 따라 지정ㆍ고시된 공익법인입니다. 기부금 모금을 통한 목적사업 추진 및 기부금 영수증 발행이
				가능하므로 기부자(법인 및 개인)는 세제 혜택을 받을 수 있습니다.
			</S.HeroDescription>
		</S.HeroCard>

		<S.InfoGrid>
			<S.Card>
				<S.CardTitle>투명한 공개와 관리</S.CardTitle>
				<S.Description>학회의 기부금 모금 및 활용실적은 국세청 및 학회 홈페이지를 통해 투명하게 관리하고 공개하고 있습니다.</S.Description>
			</S.Card>

			<S.Card>
				<S.CardTitle>공익신고 안내</S.CardTitle>
				<S.Description>기부금과 관련된 사안은 누구나 아래 연결된 링크를 통해 공익신고 하실 수 있습니다.</S.Description>
			</S.Card>
		</S.InfoGrid>

		<S.Section>
			<S.LinkCard href="https://www.clean.go.kr/index.es?sid=a1" target="_blank" rel="noreferrer">
				<S.LinkLabel>공익신고 링크</S.LinkLabel>
				<S.LinkTitle>국민권익위원회</S.LinkTitle>
				<S.LinkUrl>https://www.clean.go.kr/index.es?sid=a1</S.LinkUrl>
			</S.LinkCard>
		</S.Section>

		<S.Section>
			<S.Card>
				<S.CardTitle>문의처</S.CardTitle>
				<S.ContactList>
					<S.ContactRow>
						<S.ContactLabel>E-mail</S.ContactLabel>
						<S.ContactValue>scsk1968@naver.com</S.ContactValue>
					</S.ContactRow>
					<S.ContactRow>
						<S.ContactLabel>Tel</S.ContactLabel>
						<S.ContactValue>02-6713-1968</S.ContactValue>
					</S.ContactRow>
				</S.ContactList>
			</S.Card>
		</S.Section>
	</S.SponsorshipContainer>
);

export default SponsorshipGuide;
